import { colors } from '@lmc/common/constants'
import { capitalize } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { formatAddress } from '../../../../../../common/utils'
import { ProfileField } from '../../../../../../components/generic'
import ResidentProfileSectionWrapper from './ResidentProfileSectionWrapper'

export default function ResidentProfilePersonal({ profile }) {
  return (
    <ResidentProfileSectionWrapper
      color={colors.purple}
      icon="profile"
      style={styles.wrapper}
      title="Personal details"
    >
      <div className="lmc-card" style={styles.contentContainer}>
        {PERSONAL_INFO_FIELDS.map((field, i) => (
          <ProfileField
            key={i}
            label={field.label}
            style={styles.field}
            value={getValue(field.key, profile)}
          />
        ))}
      </div>
    </ResidentProfileSectionWrapper>
  )
}

const getValue = (key, profile) => {
  const value = profile[key]
  if (!value) return <span style={styles.noInfo}>No information entered</span>

  if (key === 'languagesSpoken') {
    return profile[key].join(', ')
  }

  if (key === 'address') {
    return formatAddress(value)
  }

  return capitalize(profile[key])
}

const PERSONAL_INFO_FIELDS = [
  {
    key: 'gender',
    label: 'Gender'
  },
  {
    key: 'address',
    label: 'Address'
  },
  {
    key: 'phoneNumber',
    label: 'Phone Number'
  },
  {
    key: 'maritalStatus',
    label: 'Marital status'
  },
  {
    key: 'birthplace',
    label: 'Birthplace'
  },
  {
    key: 'nationality',
    label: 'Nationality'
  },
  {
    key: 'languagesSpoken',
    label: 'Language(s) spoken'
  },
  {
    key: 'ethnicity',
    label: 'Ethnicity'
  },
  {
    key: 'religion',
    label: 'Religion'
  },
  {
    key: 'sexualPreference',
    label: 'Sexual Preference'
  }
]

const styles = {
  field: {
    textAlign: 'left'
  },
  noInfo: {
    color: colors.black
  },
  wrapper: {
    marginTop: '-10px'
  }
}

ResidentProfilePersonal.propTypes = {
  profile: PropTypes.object.isRequired
}
